// extracted by mini-css-extract-plugin
export default {"title":"styles_title__RTg5K","fade-in":"styles_fade-in__ixkmu","animate":"styles_animate__780wC"};